export const STORE_PREFIX = 'LI/TENANTSUIT';
